export const PrimaryColor = '#008944';
export const SecondaryColor = '#000000';
export const LightColor = '#ffffff';
